import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: must be that way
export const APP_RUNTIME_ID: DiToken<number> = new DiToken<number>('appRuntimeId');
